import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCheckboxChecked = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		width: 18,
		height: 18,
		rx: 2
	}), /* @__PURE__ */ _jsx("path", {
		fill: "#fff",
		fillRule: "evenodd",
		d: "m15.451 5.55-8.289 8.289-4.614-4.614 1.419-1.418 3.195 3.195 6.871-6.87z",
		clipRule: "evenodd"
	})]
});
export default SvgCheckboxChecked;
